@if (query || chartData) {
  <div class="card-wrapper">
    <div class="card" #cardContainer>
      <div class="card-header">
        <app-heading [text]="title" [level]="'h3'"></app-heading>
        @if (showSelect()) {
          <div class="select-wrapper" #selectComponent>
            <app-ui-select
              [disabled]="false"
              [error]="false"
              [options]="dropdownOptions"
              [menuMaxHeight]="menuMaxHeight"
              (selectionChange)="onSelectionChange($event)"
              [isResponsive]="true"
            ></app-ui-select>
          </div>
        }
      </div>
      <div class="card-body">
        @if (chartData) {
          <app-ui-pie-chart [chartData]="chartData" [width]="pieChartWidth" [isClickable]="isClickable()" [transparentIconColor]="transparentIconColor"></app-ui-pie-chart>
        } @else {
          <app-ui-pie-chart [queryConfig]="queryConfig" [query]="query" [width]="pieChartWidth" [isClickable]="isClickable()" [transparentIconColor]="transparentIconColor"></app-ui-pie-chart>
        }
      </div>
    </div>
  </div>
}
